module.exports = __webpack_public_path__ + "img/pantalla6-1.6d2d690f.png";